import { Box, Button, TextField, Typography, IconButton, Checkbox, FormControlLabel } from '@mui/material';
import { useEffect, useState } from 'react';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import SaveIcon from '@mui/icons-material/Save';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { decrypt, encrypt } from '../../../Security';
import TextBoxWithCheckbox from './TextBoxWithCheckbox';

const VV = { primary: '#3F2B96', secondary: '#7F5AF0', accent: '#00C896', border: 'rgba(63,43,150,0.10)' };

function Agenda({ agenda, removeAgenda, agendas, setAgendas, index, repId }) {
  const [title, setTitle] = useState('');
  const [detail, setDetail] = useState('');
  const [checkpoints, setCheckpoints] = useState([]);

  useEffect(() => {
    setTitle(agenda.topic || '');
    setDetail(agenda.detail || '');
    setCheckpoints(agenda.checkPoints || []);
  }, [agenda]);

  useEffect(() => {
    const ag = [...agendas];
    if (title !== '' && detail !== '') {
      ag[index] = { topic: title, detail, checkPoints: checkpoints, _id: agenda._id };
      setAgendas(ag);
    }
  }, [title, detail, checkpoints]);

  const updateRepAgenda = async () => {
    try {
      const response = await fetch(process.env.REACT_APP_PUBLIC_SERVER_URI + '/api/v1/reps/updateRepresentativeSingleAgenda/', {
        method: 'PATCH', headers: { 'Content-Type': 'application/json' }, credentials: 'include',
        body: encrypt({ repId, agenda: { _id: agenda._id, topic: title, detail, checkPoints: checkpoints } }),
      });
      const data = decrypt(await response.json());
      if (data.msg === 'SUCCESS') alert('Agenda updated: ' + title);
      else alert('Error: ' + data.msg);
    } catch (error) { console.error(error); }
  };

  const addCheckPoint = () => setCheckpoints(chp => [...chp, { text: '', checkedState: false }]);
  const removeCheckpoint = (cp) => setCheckpoints(checkpoints.filter(c => c !== cp));
  const askForConfirmation = () => { if (window.confirm('Delete this agenda?')) removeAgenda(agenda); };

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 1.5 }}>
        <Button variant="outlined" color="error" size="small" startIcon={<HighlightOffIcon />} onClick={askForConfirmation}
          sx={{ borderRadius: '8px', fontSize: '0.75rem' }}>Delete Agenda</Button>
      </Box>

      <TextField variant="outlined" fullWidth size="small" label="Agenda Title" value={title}
        onChange={e => setTitle(e.target.value)} required sx={{ mb: 2, '& .MuiOutlinedInput-root': { borderRadius: '10px', '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: VV.secondary } } }} />

      <TextField variant="outlined" fullWidth multiline minRows={4} label="Description" value={detail}
        onChange={e => setDetail(e.target.value)} required sx={{ mb: 2.5, '& .MuiOutlinedInput-root': { borderRadius: '10px', '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: VV.secondary } } }} />

      <Box sx={{ mb: 2 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
          <Typography variant="body2" sx={{ fontWeight: 700, color: VV.primary }}>Checkpoints</Typography>
          <Button size="small" startIcon={<AddCircleOutlineIcon />} onClick={addCheckPoint}
            sx={{ borderRadius: '8px', fontSize: '0.75rem', color: VV.accent, borderColor: VV.accent }}
            variant="outlined">Add</Button>
        </Box>
        {checkpoints.map((checkpoint, i) => (
          <TextBoxWithCheckbox key={i} checkpoint={checkpoint} checkpoints={checkpoints} setCheckpoints={setCheckpoints} id={i} removeCheckpoint={removeCheckpoint} />
        ))}
      </Box>

      <Button onClick={updateRepAgenda} variant="contained" startIcon={<SaveIcon />}
        sx={{ borderRadius: '10px', background: `linear-gradient(135deg, ${VV.primary}, ${VV.secondary})`, fontWeight: 700, boxShadow: '0 4px 12px rgba(63,43,150,0.3)', '&:hover': { boxShadow: '0 6px 20px rgba(63,43,150,0.4)' } }}>
        Save Agenda
      </Button>
    </Box>
  );
}

export default Agenda;
